import React__default, { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import MessageBubble from '../MessageBubble/index.js';
import styles from './styles.css.js';

var MessageVideoPart =
/** @class */
function (_super) {
  __extends(MessageVideoPart, _super);

  function MessageVideoPart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MessageVideoPart.prototype.getMessageFromPart = function (part) {
    return part.message;
  };

  MessageVideoPart.prototype.getVideoMessagePartUrl = function (messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  MessageVideoPart.prototype.render = function () {
    var message = this.getMessageFromPart(this.props.part);
    var sourceUrl = this.getVideoMessagePartUrl(this.props.part);
    return React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement("video", {
      src: sourceUrl,
      className: styles.video,
      controls: true,
      onLoad: this.props.onLoaded
    }, "Sorry, your browser doesn't support embedded videos, but don't worry, you can", ' ', React__default.createElement("a", {
      href: sourceUrl,
      target: "_blank"
    }, "download it"), ' ', "and watch it with your favorite video player!"));
  };

  return MessageVideoPart;
}(Component);

export default MessageVideoPart;
//# sourceMappingURL=index.js.map
